module.exports = __webpack_public_path__ + "static/img/Inspiron_15_7567.e37094bd.png";